const baseMarkupSchema = (graphs: any[]) => {
  return {
    '@context': 'https://schema.org',
    '@graph': graphs,
  };
};

export default baseMarkupSchema;
